"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerMessage = void 0;
var PlayerMessage;
(function (PlayerMessage) {
    class PartyInvite {
        constructor(_id, sentById, sentToId, sentAt, partyId, partySecret) {
            this._id = _id;
            this.sentById = sentById;
            this.sentToId = sentToId;
            this.sentAt = sentAt;
            this.partyId = partyId;
            this.partySecret = partySecret;
            this.__type = "PartyInvite";
        }
    }
    PlayerMessage.PartyInvite = PartyInvite;
    class DirectMessage {
        constructor(_id, sentById, sentToId, sentAt, messageText) {
            this._id = _id;
            this.sentById = sentById;
            this.sentToId = sentToId;
            this.sentAt = sentAt;
            this.messageText = messageText;
            this.__type = "DirectMessage";
        }
    }
    PlayerMessage.DirectMessage = DirectMessage;
    class ChannelMessage {
        constructor(_id, sentById, channel, sentAt, messageText) {
            this._id = _id;
            this.sentById = sentById;
            this.channel = channel;
            this.sentAt = sentAt;
            this.messageText = messageText;
            this.__type = "ChannelMessage";
        }
    }
    PlayerMessage.ChannelMessage = ChannelMessage;
})(PlayerMessage = exports.PlayerMessage || (exports.PlayerMessage = {}));
